<form [formGroup]="form" novalidate class="d-inline-block">
    <input type="file" id="{{ id }}" class="form-control" formControlName="files" (change)="runUpload($event)" [attr.multiple]="multiple" hidden>
    <button type="button" class="btn btn-info-outline" [class.btn-sm]="sm" [class.b-btn-slim]="slim" [clrLoading]="loading" (click)="runPick()">
        <ng-content></ng-content>
    </button>
</form>
